/** @jsxImportSource preact */
import { hydrate } from "preact/compat";
import { PasswordToggle } from "./components/password-toggle";

const passwords = document.querySelectorAll("[data-password]");
passwords.forEach((password) => {
  hydrate(<PasswordToggle />, password);
});
